import React, { useState } from "react";
import TopicReaction from "./TopicReaction";
import TopicReactionMessage from "./ReactionDailogue";
import { ReactComponent as ChatIcon } from "assets/img/icons/comment.svg";
import CommentsList from "./CommentsList";
import { useMoodsContext } from "store/contexts/moodsContext";
import Scrollbar from "react-scrollbars-custom";

export default ({ post }) => {
  const { moods } = useMoodsContext();
  const [expressionsOpen, setExpressionsOpen] = useState(false);

  return (
    <>
      <TopicReactionMessage
        post={post}
        openEngagement={() => setExpressionsOpen(!expressionsOpen)}
      />
      <div className="post-footer">
        <div className="post-actions">
          <div className="left-actions">
            {Boolean(moods) && Boolean(moods.length) && (
              <TopicReaction post={post} />
            )}
            <span
              className="p-comment-btn"
              onClick={() => setExpressionsOpen(!expressionsOpen)}
            >
              <ChatIcon className="mwh-15" style={{ fill: "#6c737e" }} />{" "}
              Comment
            </span>
          </div>
        </div>
      </div>
      {expressionsOpen && (
        <Scrollbar className={"topicScrollDialog"}>
          <CommentsList post={post} />
        </Scrollbar>
      )}
    </>
  );
};
